import { BaseRHFWidgetProps } from "@impero-com/common/components/form/rhfFields/types";
import { FieldValues, useController } from "react-hook-form";

import {
    SelectMultipleInput,
    SelectMultipleInputBaseProps,
    SelectMultipleValueType,
} from "../fields/selectMultipleInput";

interface RHFSelectMultipleInputProps<TFieldsValues extends FieldValues>
    extends
        BaseRHFWidgetProps<
            TFieldsValues,
            SelectMultipleValueType[] | undefined
        >,
        SelectMultipleInputBaseProps<SelectMultipleValueType> {
    onBlur?: () => void;
}

export function RHFSelectMultipleInput<TFieldsValues extends FieldValues>({
    name,
    control,
    options,
    label,
    filterOption,
    placeholder,
    className,
    nodeAfter,
    helpText,
    getPopupContainer,
    dropdownMatchSelectWidth,
    disabled,
    autoFocus,
    showSearch,
    sortValues,
    onSearch,
    onBlur,
}: RHFSelectMultipleInputProps<TFieldsValues>) {
    const { field, fieldState } = useController({ name, control, disabled });

    const handleBlur = () => {
        field.onBlur();
        onBlur?.();
    };

    return (
        <SelectMultipleInput
            label={label}
            options={options}
            filterOption={filterOption}
            value={field.value || []}
            className={className}
            nodeAfter={nodeAfter}
            helpText={helpText}
            getPopupContainer={getPopupContainer}
            dropdownMatchSelectWidth={dropdownMatchSelectWidth}
            showSearch={showSearch}
            sortValues={sortValues}
            onSearch={onSearch}
            onChange={field.onChange}
            onBlur={handleBlur}
            error={fieldState.error?.message}
            placeholder={placeholder}
            disabled={field.disabled}
            autoFocus={autoFocus}
            fieldRef={field.ref}
        />
    );
}
